import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=49e5aa0a&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=ts"
export * from "./TextArea.vue?vue&type=script&lang=ts"
import style0 from "./TextArea.vue?vue&type=style&index=0&id=49e5aa0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e5aa0a",
  null
  
)

export default component.exports